import React, { FC } from "react";
import classNames from "classnames/dedupe";

export type TSkeletonVariants =
  | "default"
  | "xsmall"
  | "medium"
  | "small"
  | "large";

export type TSkeletonCorners = "sharp" | "rounded" | "circle";

export interface ISkeletonProps {
  /**
   * Sets of predefined height for the skeleton bar
   */
  variant?: TSkeletonVariants;
  /**
   * Sets of predefined border radiu for skeleton bar
   */
  corner?: TSkeletonCorners;
  /**
   * Custom incline-css width
   */
  width?: number | string;
  /**
   * Custom incline-css height
   */
  height?: number | string;
  /**
   * The custom set of css classes used to style component
   */
  classes?: {
    /**
     * applied to outer 'div' element
     */
    root?: string;
  };
}

const Skeleton: FC<ISkeletonProps> = ({
  variant = "default",
  corner,
  width = null,
  height = null,
  classes,
}) => {
  const rootClasses = classNames(classes?.root, "skeleton-box", {
    "skeleton-box__xsmall": variant === "xsmall",
    "skeleton-box__small": variant === "small",
    "skeleton-box__medium": variant === "medium",
    "skeleton-box__large": variant === "large",
    "skeleton-box__sharp": corner === "sharp",
    "skeleton-box__rounded": corner === "rounded",
    "skeleton-box__circle": corner === "circle",
  });

  const customStyle = {
    width: `${width}`,
    height: `${height}`,
  };

  return <span className={rootClasses} style={customStyle} />;
};

export default Skeleton;
